module.exports = __webpack_public_path__ + "img/Cuidados_ao_Paciente_Ostomizado.8d230e15.jpg";